import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../config/authAxios"



const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const unfavoriteAction = createAsyncThunk(
    'add-unfavorite',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/users/api//remove-favorite`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const unfavoriteSlice = createSlice({
    name: 'add-unfavorite',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(unfavoriteAction.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(unfavoriteAction.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(unfavoriteAction.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const unfavoriteReducer = unfavoriteSlice.reducer